import { FunctionComponent } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { ClearFilterButton } from '@cbridge-tools/filters-panel';
import { StreamsFilterAction } from '../../../streamsFilter.action';
import { selectedStreamIdSelector } from '../../../_selectors/selectedStreamId.selector';

export const StreamsFilterClearButton: FunctionComponent = () => {
  const dispatch = useDispatch();
  const selectedStream = useSelector(selectedStreamIdSelector);

  const handleClearFilter = () => {
    dispatch(StreamsFilterAction.clearSelect());
  };

  return (
    <ClearFilterButton
      isShown={!!selectedStream}
      onClick={handleClearFilter}
    />
  );
};
